var fails = require('./fails');

module.exports = fails(function () {
  // babel-minify transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
  var re = RegExp('.', (typeof '').charAt(0));
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@okta/okta-idx-js/node_modules/core-js/internals/regexp-unsupported-dot-all.js
// module id = 1267
// module chunks = 0